import {
  textValidator,
} from 'app/components/Form/utils/validators';
import Reports from 'app/i18n/Reports';

export const SITE_FORM_RULES = {
  siteId: {
    validate: textValidator('PROCURE_3016'),
  },
};